import { useQuery } from '@apollo/client';
import { useNotifications } from '@risksmart-app/components/src/notifications/useNotifications';
import { GetChangeRequestsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import { useGetChangeRequestsRegisterTRPC } from './useGetChangeRequestsRegisterTRPC';

interface UseGetChangeRequestsParams {
  currentUserId: string;
  skip?: boolean;
}

export const useGetChangeRequests = ({
  currentUserId,
  skip,
}: UseGetChangeRequestsParams) => {
  const trpcEnabled = useIsFeatureVisibleToOrg('trpc');
  const { addNotification } = useNotifications();

  const {
    data: graphqlData,
    loading: graphqlLoading,
    refetch: graphqlRefetch,
  } = useQuery(GetChangeRequestsDocument, {
    fetchPolicy: 'no-cache',
    variables: {
      currentUserId,
    },
    skip: trpcEnabled || skip || !currentUserId, // Skip GraphQL query when TRPC is enabled
    onError: (error) => {
      if (!trpcEnabled) {
        addNotification({
          type: 'error',
          content: <>{error.message}</>,
        });
      }
    },
  });

  const {
    data: trpcData,
    loading: trpcLoading,
    refetch: trpcRefetch,
  } = useGetChangeRequestsRegisterTRPC({
    currentUserId,
    skip,
  });

  // Return appropriate data based on feature flag
  if (trpcEnabled) {
    return {
      loading: trpcLoading,
      data: trpcData,
      refetch: () => trpcRefetch(),
    };
  }

  return {
    loading: graphqlLoading,
    data: graphqlData,
    refetch: () => graphqlRefetch(),
  };
};
